// Helper: turns a possibly-relative image path (e.g. /api/files/yup/uploads/xxx.png)
// into an absolute URL rooted at REACT_APP_BACKEND_URL so images work even when
// frontend and backend are served from different domains (Railway prod).
const BACKEND = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export function toAbsoluteMediaUrl(url) {
  if (!url) return '';
  // Already absolute (http/https), data URI, or backend-relative? leave as-is.
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith('//')) return `https:${url}`;
  if (url.startsWith('/')) return `${BACKEND}${url}`;
  // Relative fragment — assume backend-hosted upload
  return `${BACKEND}/${url}`;
}
